module.exports = "/images/logoOnlineCredibanco.svg";